import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentTabsDto extends EpimsBaseEntityDto {
  
  TabName: string;
  TabDescription: string;
  TabInstructions: string;
  SubscriptionUserId: string;  
  Version: number;
}
